export default [
  {
    path: '/position/offers/',
    name: 'position-offers',
    meta: { is_paginatable: true, isPositionOffers: true },
    component: () =>
        import(/* webpackChunkName: "position" */ '@/components/positions/offers/Offers.vue')
  },
  {
    path: '/position/questions/',
    name: 'position-questions',
    component: () =>
        import(/* webpackChunkName: "position" */ '@/components/positions/questions/Questions.vue')
  },
  {
    path: '/position/educations/',
    name: 'position-educations',
    component: () =>
        import(/* webpackChunkName: "position" */ '@/components/positions/educations/Educations.vue')
  },
  {
    path: '/position/languages/',
    name: 'position-languages',
    component: () =>
        import(/* webpackChunkName: "position" */ '@/components/positions/languages/Languages.vue')
  },
  {
    path: '/position/texts/',
    name: 'position-texts',
    component: () =>
        import(/* webpackChunkName: "position" */ '@/components/positions/texts/Texts.vue')
  },
  {
    path: '/position/locations/',
    name: 'position-locations',
    component: () =>
        import(/* webpackChunkName: "position" */ '@/components/positions/locations/Locations.vue')
  },
  {
    path: '/position/skills/',
    name: 'position-skills',
    component: () =>
        import(/* webpackChunkName: "position" */ '@/components/positions/skills/Skills.vue')
  }
]
